import React, { useState, useEffect  } from 'react';
import { Helmet } from 'react-helmet';
import { message, Spin  } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../styles/Dashboard.css';
import avatar from '../uploads/avatar.png';
import NavBar from '../components/Dashboard/NavBar';
import DashboardContent from '../components/Dashboard/DashboardContent';
import { API_URL, API_username, API_password } from '../utils/api';

function Dashboard() {
	useEffect(() => {
		getShortInfo();		
	}, []);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [shortInfo, setShortInfo] = useState({
		status: '',
		Name: '',
		EmailWork: '',
		EmailPersonal: '',
		Photo: '',
		MobilePhoneWork: {
		value: '',
		comment: '',
		type: '',
		countryCode: '',
		areaCode: '',
		number: '',
		extNumber: ''
		},
		MobilePhonePersonal: {
		value: '',
		comment: '',
		type: '',
		countryCode: '',
		areaCode: '',
		number: '',
		extNumber: ''
		}
	});
	

  	const getShortInfo = () => {
		let apiUrl = `${API_URL}/lk?method=getshortinfo&inbody=0`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			}
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, авторизуйтесь заново!');
				navigate('/logout');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				setShortInfo(data);
				localStorage.setItem('shortinfo', JSON.stringify(data));
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		}).finally(() => {
			setLoading(false);
		});
	};

	const handleSetActive = (e) => {
		const activeElements = document.querySelectorAll('.active');
		activeElements.forEach(element => {
		  element.classList.remove('active');
		});
		e.target.classList.add('active');
	};
	
	document.querySelectorAll('.dashboard-menu-item').forEach(item => {
		item.addEventListener('click', handleSetActive);
	});
	
	const imageUrl = shortInfo.Photo ? `data:image/jpeg;base64, ${shortInfo.Photo}` : avatar;

	return (
		<div>
			<Helmet>
				<title>Личный кабинет сотрудника Enter Engineering</title>
			</Helmet>			
			<div className='dashboard'>
				<NavBar shortInfo={shortInfo} />
				<div className='dashboard-content'>
					{loading && (<div className='loader-container'>
						<Spin size="large"/>
					</div>)}
					<DashboardContent setLoading={setLoading} />
					{/* <DashboardContent setLoading={setLoading} passwordChangeRequired={shortInfo.PasswordChangeRequired} /> */}
				</div>
			</div>
		</div>
	);
}

export default Dashboard;
